
import React from "react";

interface VerificationStatusProps {
  isLoading: boolean;
  verificationStatus: "verifying" | "success" | "error";
}

const VerificationStatus: React.FC<VerificationStatusProps> = ({ 
  isLoading, 
  verificationStatus 
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-golf-50 to-white flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center">
        {isLoading ? (
          <div className="text-center space-y-4">
            <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]" role="status">
              <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
            </div>
            <p className="mt-4 text-golf-600 font-medium">Vérification en cours...</p>
          </div>
        ) : (
          <div className="space-y-4">
            {verificationStatus === "success" ? (
              <>
                <div className="text-green-500 text-5xl mb-4">✓</div>
                <h2 className="text-2xl font-bold text-gray-800">Vérification réussie!</h2>
                <p className="text-gray-600">Votre compte a été vérifié avec succès.</p>
                <p className="text-gray-600">Vous allez être redirigé vers la page d'accueil...</p>
              </>
            ) : verificationStatus === "error" ? (
              <>
                <div className="text-red-500 text-5xl mb-4">✗</div>
                <h2 className="text-2xl font-bold text-gray-800">Erreur de vérification</h2>
                <p className="text-gray-600">La vérification de votre compte a échoué.</p>
                <p className="text-gray-600">Vous allez être redirigé vers la page de connexion...</p>
              </>
            ) : (
              <p className="text-golf-600">Redirection...</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default VerificationStatus;
